import { Bot, FileSearch, Video } from "lucide-react"

const features = [
  {
    icon: Bot,
    title: "AI Vacancy Creation",
    description:
      "Generate compelling, optimised job descriptions in seconds. Our AI crafts vacancies tailored to attract the right talent for your role.",
  },
  {
    icon: FileSearch,
    title: "AI Candidate Screening",
    description:
      "Automatically rank and screen applicants based on qualifications and fit. Spend less time reviewing CVs and more time on the best candidates.",
  },
  {
    icon: Video,
    title: "AI Video Interviews",
    description:
      "Send AI-powered video interview invitations to shortlisted candidates. Review responses on your own time and make faster, smarter hiring decisions.",
  },
]

export default function AIFeaturesSection() {
  return (
    <section id="ai-features" className="py-24 bg-background">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Heading */}
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-md font-bold text-cyan-500 uppercase tracking-widest mb-3">
            Powered by AI
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground">
            Hire smarter
          </h2>
          <p className="mt-4 text-base text-muted-foreground">
            From posting a vacancy to onboarding your new hire — AI handles the
            heavy lifting at every step.
          </p>
        </div>

        {/* Cards */}
        <div className="mx-auto mt-16 grid max-w-lg grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="relative rounded-2xl border border-border bg-[#f7f8fd] p-8 shadow-sm hover:shadow-md transition-shadow duration-200"
            >
              <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-[#1A237E] to-[#283593]">
                <feature.icon className="h-6 w-6 text-cyan-400" />
              </div>
              <h3 className="text-lg font-semibold text-foreground">
                {feature.title}
              </h3>
              <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
              {/* Bottom accent */}
              <div className="absolute bottom-0 left-0 h-1 w-full rounded-b-2xl bg-gradient-to-r from-[#1A237E] to-cyan-400" />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
